import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { transformationsData } from '../utils/mockData';

const Transformations = () => {
  const handleFreeConsultation = () => {
    const message = encodeURIComponent("Hi Aaron, I've seen your transformation results and I'd like to book a free consultation to discuss my fitness goals.");
    window.open(`https://wa.me/447787166065?text=${message}`, '_blank');
  };

  return (
    <section id="transformations" className="section-padding">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="section-title">Success Stories</h2>
          <div className="section-title-underline"></div>
          <p className="section-description">
            Real transformations from real clients in Portsmouth
          </p>
        </div>

        <div className="transformations-grid-simple">
          {transformationsData.map((transformation) => (
            <div key={transformation.id} className="transformation-image-card">
              <img 
                src={transformation.beforeImage} 
                alt={`${transformation.clientName} transformation`}
                className="transformation-photo"
              />
            </div>
          ))}
        </div>

        {/* Free Consultation CTA */}
        <div className="consultation-cta">
          <h3 className="consultation-cta-title">Ready to Start Your Transformation?</h3>
          <p className="consultation-cta-text">Book a free consultation and let's discuss how I can help you achieve your goals</p>
          <Button 
            onClick={handleFreeConsultation}
            className="consultation-cta-button"
            size="lg"
            data-testid="free-consultation-btn"
          >
            <MessageCircle size={20} />
            Book Free Consultation
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Transformations;
